import { BrowseFilmTileFragment, FilmSessionFragment } from "@generated-types"
import { formatNiceDate } from "@utils/date-format"
import dayjs from "dayjs"

export function getFilmMeta(film: BrowseFilmTileFragment) {
  const filmMeta: string[] = []

  if (film.credits?.director?.length) {
    filmMeta.push("Directed by " + film.credits.director.join(", "))
  }
  if (film.filmInfo?.year) {
    filmMeta.push(film.filmInfo.year)
  }
  if (film.filmInfo?.primaryCountry) {
    filmMeta.push(film.filmInfo.primaryCountry)
  }
  if (film.eventInfo?.runtime) {
    filmMeta.push(film.eventInfo.runtime + " mins")
  }
  return filmMeta
}

export function getFilmMetaWithSessions(film: BrowseFilmTileFragment) {
  const filmMeta: string[] = []

  if (film.credits?.director?.length) {
    filmMeta.push(film.credits.director.join(", "))
  }
  if (film.filmInfo?.primaryCountry) {
    filmMeta.push(film.filmInfo.primaryCountry)
  }

  let next = film.sessions
    ?.map((session) => {
      return dayjs(session?.info?.dateTime)
    })
    .filter((session) => {
      return session.isAfter(dayjs())
    })
    .sort((a, b) => a.diff(b))
  if (next?.length! >= 2) {
    filmMeta.push(`${next?.length} more screenings`)
  } else if (next?.length! === 1) {
    filmMeta.push(formatNiceDate(next![0] as any))
  }

  return filmMeta
}

export function getFilmMetaForSession(film: BrowseFilmTileFragment, session: FilmSessionFragment) {
  const filmMeta: string[] = []

  if (film.credits?.director?.length) {
    filmMeta.push(film.credits.director.join(", "))
  }
  if (film.filmInfo?.primaryCountry) {
    filmMeta.push(film.filmInfo.primaryCountry)
  }

  let next = film.sessions
    ?.map((session) => {
      return dayjs(session?.info?.dateTime)
    })
    .filter((session) => {
      return session.isAfter(dayjs())
    })
    .sort((a, b) => a.diff(b))
  if (next?.length! >= 2) {
    filmMeta.push(`${next?.length} more screenings`)
  } else if (next?.length! === 1) {
    filmMeta.push(formatNiceDate(next![0] as any))
  }

  return filmMeta
}
